export const APP_ENTRYPOINT = process.env.REACT_APP_ENTRYPOINT
export const APP_LOGIN_PATH = 'token';
export const APP_REFRESH_TOKEN_PATH = 'token/refresh';

export const JWT_ACCESS_SECRET = process.env.REACT_APP_JWT_ACCESS_SECRET;
export const JWT_REFRESH_SECRET = process.env.REACT_APP_JWT_REFRESH_SECRET;
export const JWT_EMAIL_SECRET = process.env.REACT_APP_JWT_EMAIL_SECRET;
export const CLOUDFLARE_SITE_KEY = '0x4AAAAAAANFz6hHgH0F1NSd';
